const shopify = {
  footerMessagePaymentVia: 'Pembayaran melalui',
  inputCustomerName: 'Nama',
  inputCardExpiryDate: 'Tanggal Kedaluwarsa',
  errorInsertCardExpiration: 'Silakan masukkan tanggal kedaluwarsa kartu',
  errorCardExpired: 'Maaf! Kartu yang Anda masukkan telah kedaluwarsa',
  errorInvalidExpirationDate: 'Tanggal kedaluwarsa tidak valid',
  inputCardNumber: 'Nomor kartu',
  inputCardSecurityCode: 'Kode keamanan (CVV)',
  greeting: 'Halo, {customerName}',
  fillCardSecurityCode: 'Masukkan kode keamanan kartu',
  invalidSecurityCode: 'Kode keamanan tidak valid',
  invalidCvv: 'Kode keamanan tidak valid',
  fillColombianAddress: 'Isi kolom alamat.',
  invalidColombianAddress: 'Alamat tidak valid.',
};

module.exports = shopify;
